// const selectedFilters = (state) => {
//     let filters = [];
//     Object.keys(state.filters).forEach((key) => {
//         const selected = state.filters[key].options.filter(f => f.selected)
//             .map((s) => { return { title: s.title, type: key, value: s.value, icon: s.icon} });
//         filters = filters.concat(selected);
//     });
//     return filters;
// }

const upcoming = (state) => state.upcoming;
const past = (state) => state.past;
const fallbackImage = (state) => state.fallbackImage;

const getters = {
    upcoming,
    past,
    fallbackImage,
};

export default getters;